/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerAdmissionFlags200ResponseDataInner } from './FindAllScreenerAdmissionFlags200ResponseDataInner';
import {
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON,
} from './FindAllScreenerAdmissionFlags200ResponseDataInner';

/**
 * 
 * @export
 * @interface CreateScreenerAdmissionFlag201Response
 */
export interface CreateScreenerAdmissionFlag201Response {
    /**
     * 
     * @type {FindAllScreenerAdmissionFlags200ResponseDataInner}
     * @memberof CreateScreenerAdmissionFlag201Response
     */
    data?: FindAllScreenerAdmissionFlags200ResponseDataInner;
}

/**
 * Check if a given object implements the CreateScreenerAdmissionFlag201Response interface.
 */
export function instanceOfCreateScreenerAdmissionFlag201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateScreenerAdmissionFlag201ResponseFromJSON(json: any): CreateScreenerAdmissionFlag201Response {
    return CreateScreenerAdmissionFlag201ResponseFromJSONTyped(json, false);
}

export function CreateScreenerAdmissionFlag201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScreenerAdmissionFlag201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON(json['data']),
    };
}

export function CreateScreenerAdmissionFlag201ResponseToJSON(value?: CreateScreenerAdmissionFlag201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(value.data),
    };
}

